<template>
  <div>
    <pre class="line-numbers" :class="`language-${lang}`">
      <code>
      <slot>
      </slot>
      </code>
    </pre>
  </div>
</template>

<script>
import Prism from "prismjs";
import "prismjs/themes/prism.min.css";

import "prismjs/components/prism-scss";
import "prismjs/components/prism-markup";
import "prismjs/components/prism-ruby";

import "prismjs/plugins/toolbar/prism-toolbar";
import "prismjs/plugins/toolbar/prism-toolbar.css";

import "prismjs/plugins/line-numbers/prism-line-numbers";
import "prismjs/plugins/line-numbers/prism-line-numbers.css";

import "prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard";
import "prismjs/plugins/show-language/prism-show-language";
import "prismjs/plugins/normalize-whitespace/prism-normalize-whitespace";

export default {
  props: {
    lang: {
      type: String,
      default: "json"
    }
  },
  data() {
    return {};
  },
  mounted() {
    Prism.highlightAll();
  },
  methods: {}
};
</script>

<style></style>
